var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoData2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 102 102"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19342"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13321",
  transform: "translate(12070 18980)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M-12070-18980h102v102h-102z",
  "data-name": "Rectangle 5942"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50.947,
  cy: 50.947,
  r: 50.947,
  fill: "none",
  "data-name": "Ellipse 1501",
  transform: "translate(-12069.894 -18979.895)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 13320"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.621,
  d: "M-12037.126-18947.727h23.256",
  "data-name": "Line 961"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.621,
  d: "M-12037.126-18941.318h23.256",
  "data-name": "Line 962"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.621,
  d: "M-12037.126-18934.91h23.256",
  "data-name": "Line 963"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.621,
  d: "M-12037.126-18928.501h23.256",
  "data-name": "Line 964"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 12866"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.621,
  "data-name": "Group 12644"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-12010.452-18922.074a2.71 2.71 0 0 1 3.7-1 2.7 2.7 0 0 1 1 1l5.062 8.768 5.061 8.768a2.71 2.71 0 0 1-.993 3.7 2.7 2.7 0 0 1-1.355.362h-20.252a2.71 2.71 0 0 1-2.711-2.711 2.7 2.7 0 0 1 .363-1.355l5.062-8.767Z",
  "data-name": "Path 16453"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-12008.104-18915.666v6.465",
  "data-name": "Line 830"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-12008.104-18905.23",
  "data-name": "Line 831"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "rgba(255,255,255,0)",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.621,
  d: "M-12017.43-18910.518h-25.463v-46.9h34.791v33.568",
  "data-name": "Path 16472"
}))))));
export { SvgNoData2 as ReactComponent };
export default __webpack_public_path__ + "static/media/no_data_2.562d5f8fe8cbd51016afe88c56cec0f1.svg";